import React from 'react'
import { GridCellProps } from 'core/elements/grid/hooks/useGridRows'
import Text from 'core/elements/Text'
import { ArrayElement } from 'core/actions/Action'

interface BaseGridArrayCellProps<K extends unknown[]> {
  nameFn: (item: ArrayElement<K>) => string
}
interface GridArrayCellProps<T, K extends unknown[] = []>
  extends GridCellProps<T, K>,
    BaseGridArrayCellProps<K> {}

export default function GridArrayCell<T, K extends unknown[]>({
  value: items = [] as K,
  nameFn,
}: GridArrayCellProps<T, K>) {
  return (
    <Text lineClamp={2} variant="body2">
      {items.map((item: ArrayElement<K>) => {
        const name = nameFn(item)
        return <span key={name}>{name}</span>
      })}
    </Text>
  )
}

export function createGridArrayCell<T, K extends unknown[]>({ nameFn }: BaseGridArrayCellProps<K>) {
  return (props: GridCellProps<T, K>) => {
    return <GridArrayCell {...props} nameFn={nameFn} />
  }
}
